module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.42039/js/v2/hsoc/img/illo.svg"